<template>
  <div class="infoscreen-container">
    <TicketPortrait
      v-if="tempTicket"
      ref="tempTicket"
      :style="{ display: showTempTicket ? 'flex' : 'none' }"
      :ticket="tempTicket"
    />
    <div
      v-for="(item, index) in currentItems"
      :key="item ? item.id : -(index + 1)"
      class="infoscreen-item"
      :style="{backgroundColor: $store.infoscreenData.infoboardBackgroundColor}"
    >
      <TicketPortrait
        v-if="item"
        ref="ticketRef"
        :ticket="item"
      />
    </div>
  </div>
</template>

<script>
import TicketPortrait from '../tickets/TicketPortrait';
import TemplateMixin from '../../mixins/TemplateMixin';

export default {
  name: 'TemplatePortrait',
  components: {
    TicketPortrait
  },
  mixins: [TemplateMixin],
  computed: {
    currentItems() {
      return this.getCurrentTickets(5);
    }
  }
}
</script>

<style lang="scss" scoped>
.infoscreen-container {
  display: flex;
  flex-wrap: wrap;
  height: 100%;

  .infoscreen-item {
    width: 100%;
    height: 20%;
    padding: 0 5.5vw;

    &:nth-child(1),
    &:nth-child(2),
    &:nth-child(3),
    &:nth-child(4) {
      border-bottom-width: 8px;
      border-bottom-width: max(0.417vw, 8px);
      border-bottom-style: solid;
    }
  }
}
</style>
